import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=9a8fa084&scoped=true&"
import script from "./FieldInfo.vue?vue&type=script&lang=js&"
export * from "./FieldInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8fa084",
  null
  
)

export default component.exports